import Car from '../actors/car'
import { SPEED } from '../actors/player'

export default class Spawner {
  constructor (scene, road) {
    this.scene = scene
    this.player = scene.player
    this.road = road

    this.spawnOffset = 1500
    this.spawnRateMin = 500
    this.spawnRateMax = 1000

    this.timer = 0
    this.lastEvilSpawned = 0
  }

  spawn (x, y) {
    const isEvil = this.lastEvilSpawned >= 5 || this.scene.rnd.frac() < 0.2
    const car = new Car(this.scene, isEvil)
    this.scene.cars.add(car)
    this.scene.add.existing(car)
    car.initialize()

    car.x = x
    car.y = y
    car.speed = this.scene.rnd.realInRange(100, 200)

    if (isEvil) {
      this.lastEvilSpawned = 0
    } else {
      this.lastEvilSpawned++
    }

    return car
  }

  update (time, delta) {
    this.timer -= delta * this.player.body.velocity.y / -SPEED
    if (this.timer < 0) {
      const y = this.player.y - this.spawnOffset
      const lanes = this.road.getLanesAt(y)
      if (!this.scene.player.hasMoved) {
        lanes.splice(this.scene.player.lane, 1)
      }
      if (lanes && lanes.length > 0) {
        const x = this.scene.rnd.pick(lanes)
        this.spawn(x, y)
        this.timer += this.scene.rnd.between(this.spawnRateMin, this.spawnRateMax)
      }
    }
  }
}
